import BadWordsNext, { Data } from "bad-words-next";
import en from "bad-words-next/lib/en";

// Initialize bad-words-next with the English dataset
const badWordsInstance = new BadWordsNext({ data: en });

/**
 * Checks if the given text contains any bad words.
 * @param text The text to check.
 * @returns True if bad words are found, false otherwise.
 */
export const containsBadWords = (text: string): boolean => {
    return badWordsInstance.check(text);
};

/**
 * Cleans the given text by replacing bad words with placeholders.
 * @param text The text to clean.
 * @returns The cleaned text.
 */
export const cleanBadWords = (text: string): string => {
    return badWordsInstance.filter(text);
};

/**
 * Adds custom words to the filter list.
 * @param customWords An array of words to add.
 * @param dictionaryId A unique ID for this custom word list (e.g., 'custom-user-list').
 */
export const addCustomBadWords = (customWords: string[], dictionaryId: string = "custom"): void => {
    const customData: Data = {
        id: dictionaryId,
        words: customWords,
        lookalike: {}, // Add empty lookalike for simplicity, can be expanded if needed
    };
    badWordsInstance.add(customData);
};
